import { Component, Input, inject } from '@angular/core';
import { FileService } from '@shared/services/file';
import { FileReference } from './file-reference';

@Component({
  selector: 'app-menu-list-item-download',
  templateUrl: './menu-list-item-download.component.html',
  styleUrls: ['./menu-list-item-download.component.scss'],
  standalone: false,
})
export class MenuListItemDownloadComponent {
  private readonly fileService = inject(FileService);

  private readonly DOWNLOAD_COOLDOWN_MS = 1000;

  @Input()
  public fileReference: FileReference;

  public busy = false;

  async download(): Promise<void> {
    this.busy = true;
    try {
      const blob = await this.fileReference.getBlob();
      this.fileService.downloadToDevice(blob, this.fileReference.filename);
      await new Promise((resolve) => setTimeout(resolve, this.DOWNLOAD_COOLDOWN_MS));
    } catch (e) {
      console.error('Failed to download file', e);
    } finally {
      this.busy = false;
    }
  }
}
